// extracted by mini-css-extract-plugin
export default {"Card":"Card_Card__BzNYT","Overlay":"Card_Overlay__2Jmzf"};